class FirebaseConfigService {
  constructor() {
    this.config = null;
    this.loading = false;
    // URL of your deployed Cloud Function
    this.functionUrl = 'https://us-central1-fir-7c9c9.cloudfunctions.net/getAPIConfig';
  }

  /**
   * Fetch API configuration from Firebase Cloud Function.
   * Caches the result for future calls.
   */
  async getConfig() {
    // Return cached config if available
    if (this.config) return this.config;

    // Prevent multiple simultaneous fetches
    if (this.loading) return null;

    this.loading = true;
    try {
      const response = await fetch(this.functionUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      // Handle HTTP errors
      if (!response.ok) {
        console.error('Failed to fetch API config, status:', response.status);
        return null;
      }

      // Parse JSON safely
      this.config = await response.json();
      return this.config;
    } catch (error) {
      console.error('Failed to load API config:', error);
      return null;
    } finally {
      this.loading = false;
    }
  }
}

// Export a singleton instance
export default new FirebaseConfigService();
